import type { GameConfigClient } from './GameConfigClient';
import { LocalGameConfig } from './LocalGameConfig';
import { RemoteGameConfig } from './RemoteGameConfig';

export function createGameConfigClient(): GameConfigClient {
  const local = new LocalGameConfig();
  const url = import.meta.env.VITE_GAME_CONFIG_URL;
  if (typeof url === 'string' && url.trim()) return new RemoteGameConfig(url.trim(), local);
  return local;
}
